Oskari.bundle_manager.registerDynamic('admin-layereditor', function() {return import(/* webpackChunkName: "chunk_admin-layereditor" */ 'oskari-loader!oskari-frontend/packages/admin/bundle/admin-layereditor/bundle.js');});
